import React, { useCallback } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import Button from '../../../../../components/common/Button';
import Input from '../../../../../components/common/Input';

import * as S from './styles';

interface IProps {
  onContinue?: (data: Inputs) => void;
}

export type Inputs = {
  player1Name: string;
  player2Name: string;
};

function StartGameStep1({ onContinue }: IProps) {
  const { register, handleSubmit } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = useCallback(
    (data) => {
      onContinue && onContinue(data);
    },
    [onContinue],
  );

  return (
    <S.Form onSubmit={handleSubmit(onSubmit)}>
      <S.InputsContainer>
        <Input
          label="Name"
          id="player1Name"
          {...register('player1Name', { required: true })}
        />
        <Input
          label="Name"
          {...register('player2Name', { required: true })}
        />
      </S.InputsContainer>
      <Button
        variant="primary"
        $size="large"
        type="submit"
      >
        continue
      </Button>
    </S.Form>
  );
}

export default StartGameStep1;
